import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_2/BuildingInstructions_Images/MainModels`

const Pic1 = `${FullPath}/AlibabaAmusementRide/1_1x.png`;
const Pic2 = `${FullPath}/AlibabaAmusementRide/2_1x.png`;
const Pic3 = `${FullPath}/AlibabaAmusementRide/3_1x.png`;
const Pic4 = `${FullPath}/AlibabaAmusementRide/4_1x.png`;
const Pic5 = `${FullPath}/AlibabaAmusementRide/5_1x.png`;
const Pic6 = `${FullPath}/AlibabaAmusementRide/6_1x.png`;
const Pic7 = `${FullPath}/AlibabaAmusementRide/7_1x.png`;
const Pic8 = `${FullPath}/AlibabaAmusementRide/8_1x.png`;
const Pic9 = `${FullPath}/AlibabaAmusementRide/9_1x.png`;
const Pic10 = `${FullPath}/AlibabaAmusementRide/10_1x.png`;
const Pic11 = `${FullPath}/AlibabaAmusementRide/11_1x.png`;
const Pic12 = `${FullPath}/AlibabaAmusementRide/12_1x.png`;
const Pic13 = `${FullPath}/AlibabaAmusementRide/13_1x.png`;
const Pic14 = `${FullPath}/AlibabaAmusementRide/14_1x.png`;
const Pic15 = `${FullPath}/AlibabaAmusementRide/15_1x.png`;
const Pic16 = `${FullPath}/AlibabaAmusementRide/16_1x.png`;
const Pic17 = `${FullPath}/AlibabaAmusementRide/17_1x.png`;
const Pic18 = `${FullPath}/AlibabaAmusementRide/18_1x.png`;
const Pic19 = `${FullPath}/AlibabaAmusementRide/19_1x.png`;
const Pic20 = `${FullPath}/AlibabaAmusementRide/20_1x.png`;
const Pic21 = `${FullPath}/AlibabaAmusementRide/21_1x.png`;
const Pic22 = `${FullPath}/AlibabaAmusementRide/22_1x.png`;
const Pic23 = `${FullPath}/AlibabaAmusementRide/23_1x.png`;
const Pic24 = `${FullPath}/AlibabaAmusementRide/24_1x.png`;
const Pic25 = `${FullPath}/AlibabaAmusementRide/25_1x.png`;
const Pic26 = `${FullPath}/AlibabaAmusementRide/26_1x.png`;
const Pic27 = `${FullPath}/AlibabaAmusementRide/27_1x.png`;
const Pic28 = `${FullPath}/AlibabaAmusementRide/28_1x.png`;
const Pic29 = `${FullPath}/AlibabaAmusementRide/29_1x.png`;
const Pic30 = `${FullPath}/AlibabaAmusementRide/30_1x.png`;
const Pic31 = `${FullPath}/AlibabaAmusementRide/31_1x.png`;
const Pic32 = `${FullPath}/AlibabaAmusementRide/32_1x.png`;
const Pic33 = `${FullPath}/AlibabaAmusementRide/33_1x.png`;
const Pic34 = `${FullPath}/AlibabaAmusementRide/34_1x.png`;
const Pic35 = `${FullPath}/AlibabaAmusementRide/35_1x.png`;
const Pic36 = `${FullPath}/AlibabaAmusementRide/36_1x.png`;
const Pic37 = `${FullPath}/AlibabaAmusementRide/37_1x.png`;
const Pic38 = `${FullPath}/AlibabaAmusementRide/38_1x.png`;
const Pic39 = `${FullPath}/AlibabaAmusementRide/39_1x.png`;
const Pic40 = `${FullPath}/AlibabaAmusementRide/40_1x.png`;
const Pic41 = `${FullPath}/AlibabaAmusementRide/41_1x.png`;
const Pic42 = `${FullPath}/AlibabaAmusementRide/42_1x.png`;
const Pic43 = `${FullPath}/AlibabaAmusementRide/43_1x.png`;
const Pic44 = `${FullPath}/AlibabaAmusementRide/44_1x.png`;
const Pic45 = `${FullPath}/AlibabaAmusementRide/45_1x.png`;
const Pic46 = `${FullPath}/AlibabaAmusementRide/46_1x.png`;
const Pic47 = `${FullPath}/AlibabaAmusementRide/47_1x.png`;
const Pic48 = `${FullPath}/AlibabaAmusementRide/48_1x.png`;
const Pic49 = `${FullPath}/AlibabaAmusementRide/49_1x.png`;
const Pic50 = `${FullPath}/AlibabaAmusementRide/50_1x.png`;
const Pic51 = `${FullPath}/AlibabaAmusementRide/51_1x.png`;
const Pic52 = `${FullPath}/AlibabaAmusementRide/52_1x.png`;
const Pic53 = `${FullPath}/AlibabaAmusementRide/53_1x.png`;
const Pic54 = `${FullPath}/AlibabaAmusementRide/54_1x.png`;





export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
        Pic10,
        Pic11,
        Pic12,
        Pic13,
        Pic14,
        Pic15,
        Pic16,
        Pic17,
        Pic18,
        Pic19,
        Pic20,
        Pic21,
        Pic22,
        Pic23,
        Pic24,
        Pic25,
        Pic26,
        Pic27,
        Pic28,
        Pic29,
        Pic30,
        Pic31,
        Pic32,
        Pic33,
        Pic34,
        Pic35,
        Pic36,
        Pic37,
        Pic38,
        Pic39,
        Pic40,
        Pic41,
        Pic42,
        Pic43,
        Pic44,
        Pic45,
        Pic46,
        Pic47,
        Pic48,
        Pic49,
        Pic50,
        Pic51,
        Pic52,
        Pic53,
        Pic54,

    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}